package floris.graphics.models.dto.requests.user

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.domain.models.user.UserRoles
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: String = "",
    @SerialName("full_name")
    override val fullName: String = "",
    val username: String = "",
    @SerialName("created_at")
    override val createdAt: String = "",
    @SerialName("updated_at")
    override val updatedAt: String = "",
    val role: UserRoles = UserRoles.User
) : DateAble, NameAble